/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LookupDto } from '../models/lookup-dto';

@Injectable({
  providedIn: 'root',
})
export class SolutionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation solutionsLookup
   */
  static readonly SolutionsLookupPath = '/v1/admin/solutions/lookup';

  /**
   * Get solutions list.
   *
   * Returns the list of all available solutions like VituPay, Dealer, etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `solutionsLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  solutionsLookup$Response(params?: {
  }): Observable<StrictHttpResponse<Array<LookupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SolutionsService.SolutionsLookupPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LookupDto>>;
      })
    );
  }

  /**
   * Get solutions list.
   *
   * Returns the list of all available solutions like VituPay, Dealer, etc.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `solutionsLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  solutionsLookup(params?: {
  }): Observable<Array<LookupDto>> {

    return this.solutionsLookup$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LookupDto>>) => r.body as Array<LookupDto>)
    );
  }

}
